const util = require("util");
const moment = require("moment");

export function getLocalDateTime(givenDate) {
  const utcDate = givenDate.toString();
  const gmtDateTime = moment.utc(utcDate);
  const local = gmtDateTime.local().format("YYYY-MMM-DD h:mm A");
  return moment(local, "YYYY-MMM-DD h:mm A").format("lll");
}

export function capitalize(text) {
  return text ? text.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
    return str.toUpperCase();
  }) : ""
}

export function string_to_slug (str) {
  str = str.replace(/^\s+|\s+$/g, ''); // trim
  str = str.toLowerCase();

  // remove accents, swap ñ for n, etc
  var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
  var to   = "aaaaeeeeiiiioooouuuunc------";
  for (var i=0, l=from.length ; i<l ; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by -
      .replace(/-+/g, '-'); // collapse dashes

  return str;
}

export function getExtension(filename) {
  return /[.]/.exec(filename) ? /[^.]+$/.exec(filename) : undefined;
}
export function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}
export function getDateRange(date, rangeLimit = 31, unit = 'days') {
  const range = moment(date).utc().local();
  let limit;
  if (rangeLimit && unit) {
    limit = moment(date).add(rangeLimit, unit).endOf("day").unix()
  }
  return {
    start: range.startOf("day").toString(),
    end: range.endOf("day").toString(),
    startUnix: range.startOf("day").unix(),
    endUnix: range.endOf("day").unix(),
    limit: limit
  };
}

export const replaceElem = (array, key, value, newData) => {
  return [...array].map((elem, i) => {
    const check = key ? elem[key] : i;
    if (check === value) return { ...newData };
    return elem;
  });
};

// utils/auth.js
export const getCurrentUserRole = () => {
  try {
    return localStorage.getItem("role");
  } catch {
    return null;
  }
};

export const Util = util;
